import * as React from 'react'
import SVG from './SVG'

// "storefront" and "channel" are almost synonyms.
// All storefronts are channels, but not all channels are storefronts.

const ChannelSelector = ({
  type = 'storefront',
  store,
  channelId,
  onChannelSelect,
}) => {
  const channels = store.channels.filter((c) => c.type === type)

  const channelCount = channels.length

  const [isExpanded, setIsExpanded] = React.useState(false)

  const selectedChannel = channels.find((c) => c.id === channelId)
  if (!selectedChannel) {
    if (channelId === 1) {
      throw new Error('Default channel 1 not found!')
    }
    onChannelSelect(1)
  }

  const onClick = (channel) => {
    if (isExpanded) {
      setIsExpanded(false)
      onChannelSelect(channel.id)
    } else {
      setIsExpanded(true)
    }
  }

  // Show all channels or just the selected one?
  const channelsToShow = isExpanded ? channels : [selectedChannel]

  return (
    <div className="flex flex-col gap-0.5">
      {channelsToShow.map((channel) => {
        const isSelected = channel.name === selectedChannel?.name
        return (
          <button
            onClick={() => onClick(channel)}
            type="button"
            className={`p-2 w-full rounded-md relative text-left transition flex items-center gap-1.5 hover:bg-indigo-700 sm:hover:bg-indigo-500 hover:text-white text-white sm:text-black ${
              isSelected ? 'bg-indigo-900 sm:bg-indigo-100' : 'bg-transparent'
            }`}
          >
            <div className="bg-white p-1 rounded-full">
              <img
                src={`https://s2.googleusercontent.com/s2/favicons?domain_url=${channel?.site?.url}`}
                alt={channel.name}
                className="w-5 h-5"
              />
            </div>
            {channel.name}
            {!isExpanded && channelCount > 1 && <SVG name="downArrow" />}
          </button>
        )
      })}
    </div>
  )
}

export default ChannelSelector
